import {Component, OnInit} from '@angular/core';
import {ApiService} from "../services/api.service";
import {DataService} from "../services/data.service";
import {Category} from "../type/category";

@Component({
    selector: 'app-company-category',
    templateUrl: './company-category.component.html',
})
export class CompanyCategoryComponent implements OnInit {

    node = 'company-category';
    companyCategories: [Category] = [Category];

    isChecked = false;
    checkedList = [];

    constructor(
        private dataService: DataService,
        private apiService: ApiService
    ) {}

    ngOnInit() {
        this.dataService.refresh();
        this.getAll();
    }

    resetData() {
        this.getAll();
        this.isChecked = false;
        this.checkedList = [];
    }

    getAll(): void {
        this.apiService.getSubCatAll(this.node)
            .subscribe((response) => {
                this.dataService.updateActiveRequestNo(-1);
                if (response.json().error == true) {
                    this.companyCategories = [Category];
                } else {
                    this.companyCategories = response.json().data;
                }
            });
    }



    onDelete() {
        if (confirm('Are you absolutely sure you want to delete?')) {
            this.apiService.delete(this.node, this.checkedList)
                .subscribe((response) => {
                    this.dataService.updateActiveRequestNo(-1);
                    if (response.json().error == true) {
                        alert('Unable to delete Company Category');
                    } else {
                        alert('Company Category Deleted Successfully');
                    }
                    this.resetData();
                });
        }
    }

    updateCheckList(id) {
        if (this.checkedList.indexOf(id) == -1) {
            this.checkedList.push(id);
        } else {
            this.checkedList.splice(this.checkedList.indexOf(id), 1);
        }
    }

    toggleCheckBox() {
        this.isChecked = !this.isChecked;
        if (this.isChecked == true) {
            this.checkedList = this.companyCategories.map(function(a) {return a.company_category_id;});
        } else {
            this.checkedList = [];
        }
    }

    checkPermission(module, method) {
        return this.dataService.checkPermission(module, method);
    }

}



// WEBPACK FOOTER //
// ./src/app/company-category/company-category.component.ts